<template>
  <!-- Create New Rich Menu Modal Start -->
  <div
    class="modal fade bd-example-modal"
    id="create-edit-rich-menu-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal modal-dialog-centered" role="document">
      <div class="modal-content tag-modal">
        <div class="modal-header">
          <p class="modal-title text-bold" v-if="!editMode">
            {{ $t("__AddRichMenu") }}
          </p>
          <p class="modal-title text-bold" v-if="editMode">
            {{ $t("__EditRichMenu") }}
          </p>

          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container-fluid" style="height: 60vh; overflow: auto">
            <div>
              <span class="text-danger">*</span> {{ $t("__requiredItem") }}
            </div>
            <label class="pt-3 mb-2">{{ $t("__RichMenuname") }}</label>
            <div class="row">
              <input
                type="text"
                class="form-control px-4 mx-3"
                :placeholder="$t('__RichMenuname')"
                :disabled="editMode"
                v-model="formInput.name"
              />
            </div>

            <label class="pt-3 mb-2"
              ><span class="text-danger">*</span>
              {{ $t("__RichMenuText") }}</label
            >
            <div class="row">
              <input
                type="text"
                class="form-control px-4 mx-3"
                :placeholder="$t('__RichMenuText')"
                v-model="formInput.chatBarText"
              />
            </div>

            <label class="pt-3 mb-2"
              ><span class="text-danger">*</span>
              {{ $t("__background") }}</label
            >
            <div
              v-bind:class="{
                'layout-image-container-1': isImageClass1,
                'layout-image-container-2': isImageClass2,
              }"
              @click="$refs.imageInput.click()"
            >
              <input
                ref="imageInput"
                type="file"
                accept="image/*"
                @change="onImageChanged($event)"
                :disabled="editMode"
                style="display: none"
              />
              <img
                :src="formInput.imageB64"
                v-if="formInput.imageB64 != ''"
                style="width: 100%"
              />
              <span
                class="layout-image-hint"
                v-if="formInput.imageB64 == '' && !editMode"
                >{{ $t("__selectImage") }}</span
              >
            </div>
            <p class="mt-1" style="font-size: 11px">{{ imageSizeHint }}</p>

            <label class="pt-3 mb-2"
              ><span class="text-danger">*</span> {{ $t("__richMsgLayout") }}</label
            >
            <div class="container">
              <div class="row">
                <div class="container col-4" @click="onLayoutChanged('A')">
                  <div
                    class="row layout-container"
                    v-bind:class="{
                      'layout-selected': formInput.layout === 'A',
                    }"
                  >
                    <div
                      class="col-4 layout-unit"
                      v-bind:class="{
                        'layout-selected': formInput.layout === 'A',
                      }"
                      v-for="n in ['A','B','C','D','E','F']"
                      :key="n"
                    >
                      <p style="text-align: center; margin-top:40%">{{ n }}</p>
                    </div>
                  </div>
                </div>
                <div class="container col-4" @click="onLayoutChanged('B')">
                  <div
                    class="row layout-container"
                    v-bind:class="{
                      'layout-selected': formInput.layout === 'B',
                    }"
                  >
                    <div
                      class="col-12 layout-unit"
                      v-bind:class="{
                        'layout-selected': formInput.layout === 'B',
                      }"
                    >
                      <p style="text-align: center;margin-top:10%">{{ 'A' }}</p>
                    </div>
                    <div
                      class="col-4 layout-unit"
                      v-bind:class="{
                        'layout-selected': formInput.layout === 'B',
                      }"
                      v-for="n in ['B','C','D']"
                      :key="n"
                    >
                      <p style="text-align: center; margin-top:40%">{{ n }}</p>
                    </div>
                  </div>
                </div>
                <div class="container col-4" @click="onLayoutChanged('C')">
                  <div
                    class="row layout-container"
                    v-bind:class="{
                      'layout-selected': formInput.layout === 'C',
                    }"
                  >
                    <div
                      class="col-4 layout-unit"
                      v-bind:class="{
                        'layout-selected': formInput.layout === 'C',
                      }"
                      v-for="n in ['A','B','C']"
                      :key="n"
                    >
                      <p style="text-align: center; margin-top:40%">{{ n }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <label class="pt-3 mb-2"
              ><span class="text-danger">*</span> {{ $t("__action") }}</label
            >
            <div
              class="action-container mb-1"
              v-for="(action, key) in formInput.areaOptions"
              :key="key"
            >
              <label class="ml-3 mt-2">{{ key }}</label>
              <div class="row px-4 mt-2">
                <md-radio
                  type="radio"
                  class="ml-3"
                  value="text"
                  :disabled="editMode"
                  v-model="action.type"
                />

                <input
                  type="text"
                  class="form-control col-10 ml-0"
                  :placeholder="$t('__Textcontent')"
                  :id="'text-' + key"
                  @focus="onActionTypeChanged($event, key)"
                  :disabled="editMode"
                  v-model="action.text"
                />
              </div>
              <div class="row px-4 mt-2">
                <md-radio
                  type="radio"
                  class="ml-3"
                  value="uri"
                  :disabled="editMode"
                  v-model="action.type"
                />

                <input
                  type="text"
                  class="form-control col-10 ml-0"
                  :placeholder="$t('__urllinkoptional')"
                  :id="'uri-' + key"
                  @focus="onActionTypeChanged($event, key)"
                  :disabled="editMode"
                  v-model="action.url"
                />
              </div>
            </div>

            <label class="pt-3 mb-2"
              ><span class="text-danger">*</span> {{ $t("__segment") }}</label
            >
            <div class="container">
              <div class="row">
                <select
                  class="form-control col-5 ml-2"
                  v-model="formInput.segmentId"
                >
                  <option value disabled selected>
                    {{ $t("__segment") }}
                  </option>
                  <option value="richAllUser">
                    {{ $t("__richAllUser") }}
                  </option>
                  <option
                    :value="segment.id"
                    v-for="(segment, index) in segmentList"
                    :key="index"
                  >
                    {{ segment.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 100%"
            @click="submitRichMenu()"
            v-if="!editMode"
          >
            {{ $t("__CreatenewRichMenu") }}
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 100%"
            @click="submitRichMenu()"
            v-if="editMode"
          >
            {{ $t("__saveRichMenu") }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Create New Rich Menu Modal End -->
</template>

<script>
import { apiFunction } from "../../../Axios/functions";

export default {
  name: "create-edit-rich-menu-modal",
  props: {
    adminId: String,
    jwtToken: String,
    accountId: String,
    segmentList: Array,
    formInput: Object,
  },
  data() {
    return {
      editMode: false,
      actionNames: ["A", "B", "C", "D", "E", "F"],
      imageSizeHint: "2500 × 1686,  1200 × 810, 800 × 540",
      imageExpectSizes: {
        A: [
          [2500, 1686],
          [1200, 810],
          [800, 540],
        ],
        B: [
          [2500, 1686],
          [1200, 810],
          [800, 540],
        ],
        C: [
          [2500, 843],
          [1200, 405],
          [800, 270],
        ],
      },
      isImageClass1: true,
      isImageClass2: false,
    };
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.$watch(
      "formInput",
      () => {
        this.loadData();
      },
      { immediate: true }
    );
  },
  methods: {
    loadData() {
      if (this.formInput.id && this.formInput.id !== "") {
        let formData = {
          adminId: this.adminId,
          accountId: this.accountId,
          richmenuId: this.formInput.id,
        };
        apiFunction.getRichMenu(formData, this.jwtToken).then((data) => {
          if (data.error) {
            this.$fire({
              title: this.$t("__authExpired"),
              text: this.$t("__pleaseLogin"),
              type: "error",
            });
            this.$router.push("/login");
          } else {
            this.formInput.imageB64 = data.data.Result.data.image_b64;
          }
        });
      }
      this.updateImageSizeHint(this.imageExpectSizes[this.formInput.layout]);
      this.updateImageClass(this.formInput.layout);
    },
    // Trigger this function once user click a specific input.
    onActionTypeChanged(event, key) {
      if (this.editMode) {
        return;
      }
      if (event.target.id.indexOf("uri") != -1) {
        this.formInput.areaOptions[key].type = "uri";
      } else if (event.target.id.indexOf("text") != -1) {
        this.formInput.areaOptions[key].type = "text";
      }
    },
    // Add new rich menu
    submitRichMenu() {
      // Check all fields are fill in.
      if (
        this.formInput.name !== "" &&
        this.formInput.segmentId !== "" &&
        this.formInput.layout !== "" &&
        this.formInput.imageB64 !== "" &&
        this.formInput.imgWidth !== "" &&
        this.formInput.imgHeight !== ""
      ) {
        // Check image size follow the official Suggest.
        var sizeOk = false;
        let targetSizes = this.imageExpectSizes[this.formInput.layout];
        targetSizes.forEach((size) => {
          if (
            this.formInput.imgWidth === size[0] &&
            this.formInput.imgHeight === size[1]
          ) {
            sizeOk = true;
          }
        });
        
        if (sizeOk) {
          // Pass all validation, we can submit form.
          $("#create-edit-rich-menu-modal").modal("hide");
          this.$emit("submitRichMenu", this.formInput);
        } else {
          return this.$fire({
            title: this.$t("__Addfailed"),
            text: this.$t("__ImageSizeIncorrect"),
            type: "error",
          });
        }
      } else {
        return this.$fire({
          title: this.$t("__Addfailed"),
          text: this.$t("__Pleasefillinallfields"),
          type: "error",
        });
      }
    },
    //Trigger this function once user selected a new image.
    onImageChanged(e) {
      if (e && e.target.files.length > 0) {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          let img = new Image();
          img.setAttribute('crossOrigin','anonymous');
          img.onload = () => {
            this.formInput.imgWidth = img.width;
            this.formInput.imgHeight = img.height;
            this.formInput.imageB64 = img.src;
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    // Update layout related data once user click layout picture.
    onLayoutChanged(layout) {
      if (this.editMode) {
        return;
      }
      this.formInput.layout = layout;
      switch (layout) {
        case "A":
          this.resetLayoutActions(6);
          break;
        case "B":
          this.resetLayoutActions(4);
          break;
        case "C":
          this.resetLayoutActions(3);
          break;
      }
      this.updateImageSizeHint(this.imageExpectSizes[layout]);
      this.updateImageClass(layout);
    },
    // Reset action data.
    resetLayoutActions(numbers) {
      var tempAreaOptions = {};
      for (var i = 0; i < numbers; i++) {
        tempAreaOptions[this.actionNames[i]] = {
          type: "text",
          text: "",
          url: "",
        };
      }
      this.formInput.areaOptions = tempAreaOptions;
    },
    updateImageSizeHint(targetSizes) {
      this.imageSizeHint = "";
      targetSizes.forEach((size) => {
        if (this.imageSizeHint === "") {
          this.imageSizeHint = this.imageSizeHint + size[0] + " x " + size[1];
        } else {
          this.imageSizeHint =
            this.imageSizeHint + ", " + size[0] + " x " + size[1];
        }
      });
      this.imageSizeHint = this.imageSizeHint + " pixels";
    },
    updateImageClass(type) {
      if (type === "A" || type === "B") {
        this.isImageClass1 = true;
        this.isImageClass2 = false;
      } else if (type === "C") {
        this.isImageClass1 = false;
        this.isImageClass2 = true;
      }
    },
  },
};
</script>
